module.exports = __webpack_public_path__ + "6cf61217b587bf6856eee81d09cf7daa.svg";